var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 30,
    height: 30,
    transform: "translate(907.353 993.566)",
    fill: "none",
    stroke: "#b7b5b6",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_53",
    "data-name": "Mask Group 53",
    transform: "translate(-907.353 -993.566)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz48",
    d: "M163.183,238.69a1.9,1.9,0,0,1-1.891-1.891V218.836H160v-1.891h5.925V216h8.32v.945h5.925v1.891h-1.292V236.8a1.939,1.939,0,0,1-1.891,1.891Zm13.8-19.854h-13.8V236.8h13.8Zm-10.463,15.253h1.891V221.515h-1.891Zm5.231,0h1.891V221.515h-1.891Zm-8.572-15.253v0Z",
    transform: "translate(752.269 780.996)",
    fill: "#a21110"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trash_bin.2623507a62d20fccbf475161a036ee94.svg";
export { ForwardRef as ReactComponent };